import { render, staticRenderFns } from "./DetalhaFechamento.vue?vue&type=template&id=0495f30e&scoped=true&"
import script from "./DetalhaFechamento.vue?vue&type=script&lang=js&"
export * from "./DetalhaFechamento.vue?vue&type=script&lang=js&"
import style0 from "./DetalhaFechamento.vue?vue&type=style&index=0&id=0495f30e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0495f30e",
  null
  
)

export default component.exports